module.exports = __webpack_public_path__ + "media/images/nav/icon_8-499bbb8f45e4e94141382a565a452095.svg";